import axios from "axios";
import { MONACO_LANG } from "../constants/languages";

const API_URL = "https://compiler.cleanerp.com/submissions";

export const executeCode = async (language, sourceCode) => {
    // Find Judge0 Language ID based on name
    const languageId = Object.keys(MONACO_LANG).find(
        (key) => MONACO_LANG[key] === language
    );

    if (!languageId) {
        throw new Error(`Language ${language} not supported`);
    }

    try {
        const response = await axios.post(`${API_URL}?base64_encoded=false&wait=true`, {
            source_code: sourceCode,
            language_id: Number(languageId),
            stdin: "",
            cpu_time_limit: 10,
            memory_limit: 51200 // 50MB
        });
        return response.data;
    } catch (error) {
        console.error("Error executing code:", error);
        throw error;
    }
};
